import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadCourseCategoryListCompletion,
  loadCourseCompletion,
  loadCourseCategoryDetailCompletion,
} from '../../actions';

export function* watchLoadCourseCategoryList() {
  yield takeEvery('LOAD_COURSE_CATEGORY_LIST', function*() {
    const options = {
      url: `/sfapi/course/index`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadCourseCategoryListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadCourse() {
  yield takeEvery('LOAD_COURSE', function*({ courseId }) {
    const options = {
      url: `/sfapi/course/${courseId}/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCourseCompletion(courseId, result.error, result.data));
  });
}

export function* watchLoadCourseCategoryDetail() {
  yield takeEvery('LOAD_COURSE_CATEGORY_DETAIL', function*({ id }) {
    const options = {
      url:
        id && id !== -1
          ? `/sfapi/course/category/detail?categoryId=${id}`
          : `/sfapi/course/category/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadCourseCategoryDetailCompletion(id, result.error, result.data)
    );
  });
}

export default function* courseSaga() {
  yield all([
    fork(watchLoadCourseCategoryList),
    fork(watchLoadCourse),
    fork(watchLoadCourseCategoryDetail),
  ]);
}
